import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ScheduleComponent } from "./schedule/schedule/schedule.component";
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { ContactsComponent } from "./contacts/contacts/contacts.component";
import { HvacLocationComponent } from "./hvacLocation/locations/location/location.component";
import { PlansComponent } from "./plans/plans/plans.component";
import { HvacHomeComponent } from "./home1/home.component";
import { CustomersComponent } from "./customers/customers/customers.component";
import { SubdivisionsComponent } from "./subdivisions/subdivisions/subdivisions.component";
import { JobtypesComponent } from "./jobs/jobtypes/jobtypes.component";
import { CitiesComponent } from "./cities/cities/cities.component";
import { EmployeesComponent } from "./employee/employee/employees.component";
import { EmployeeTreeComponent } from "./employee/employee-tree/employee-tree.component";
import { CsvreportsComponent } from "./csvreports/csvreports.component";
import { VisualmapComponent } from "./visualmap/visualmap.component";
import { CustomerJobsComponent } from "./customers/customer-jobs/customer-jobs.component";
import { BillingComponent } from "./billing/billing/billing.component";
import { RaterformComponent } from "./raterform/raterform/raterform.component";
import { HeatmapComponent } from "./heatmap/heatmap/heatmap.component";
import { VersionComponent } from "./version/version.component";
import { BuilderchecklistsComponent } from "./builder/builderchecklists/builderchecklists.component";
import { ViewJobLocationsComponent } from "./location/location.component";
import { EquipmentComponent } from "./equipment/equipment/equipment.component";
import { DesignComponent } from "./design/design/design.component";
import { DesignFormComponent } from "./design/design-form/design-form.component";
import { DesignOverviewComponent } from "./design/design-overview/design-overview.component";
import { HomesComponent } from "./homes/homes.component";
import { ViewEquipmentComponent } from "src/app/equipment/view-equipment/view-equipment.component";
import { EquipmentFormComponent } from "src/app/equipment/equipment-form/equipment-form.component";
import { SystemComponent } from "src/app/system/system/system.component";
import { ViewSystemComponent } from "src/app/system/view-system/view-system.component";
import { ViewLocationComponent } from "src/app/hvacLocation/locations/view-location/view-location.component";
import { LocationFormComponent } from "src/app/hvacLocation/locations/location-form/location-form.component";
import { SystemDesignComponent } from "src/app/design/system-design/system-design.component";
import { HelpComponent } from "src/app/help/help.component";
import { NewSystemComponent } from "src/app/system/new-system/new-system/new-system.component";
import { NewSystemDesignComponent } from "src/app/system/new-system-design/new-system-design.component";
import { ViewSystemEquipmentComponent } from "src/app/system/view-system-equipment/view-system-equipment.component";
import { NewSystemDesignRoomComponent } from "src/app/system/new-system-design-room/new-system-design-room.component";
import { LocationsSelectDesignsComponent } from "src/app/hvacLocation/locations/locations-select-designs/locations-select-designs.component";
import { ConfirmLocationDesignComponent } from "src/app/hvacLocation/locations/confirm-location-design/confirm-location-design.component";
import { LocationComponent } from "./location/location.component";
import { CopySystemComponent } from "./design/copy-system/copy-system.component";
//import { LocationComponent } from './location/location.component';
import { HVACreviewComponent } from "./location/location.component";
import { ExtraNotesRedirectComponent } from "./location/extra-notes-redirect.component";
import { AuthService } from "./auth.service";
import { HomecontainerComponent } from "./homecontainer/homecontainer.component";
import { AuthGuard } from "./_guards/index";
import { MultifamilyComponent } from "./multifamily/multifamily.component";
import { TimetrackingComponent } from "./timetracking/timetracking.component";
import { IndivAuditsComponent } from "./indiv-audits/indiv-audits.component";
import { TimeadjustmentsComponent } from "./timeadjustments/timeadjustments.component";
import { OnOurWayLogComponent } from "./onourwaylog/onourwaylog.component";
import { BuilderConfirmationsComponent } from "./builderconfirmations/builderconfirmations.component";
import { TrainingDashboardComponent } from "./training/training-dashboard/training-dashboard.component";
import { EmployeeTrainingDetailComponent } from "./training/employee-training-detail/employee-training-detail.component";


/*
let isHvacContractor = false;

auth.getUser$().subscribe(
  (res) => {
    isHvacContractor = (res.auth.role == 'HVACUser');
  }, err => {

  }
)
*/

const routes: Routes = [
  {
    path: "schedule",
    component: ScheduleComponent,
    data: { title: "Schedule", version: 1 },
    canActivate: [AuthGuard],
  },
  {
    path: "officesched",
    component: ScheduleComponent,
    data: { title: "Office Schedule", version: 2 },
    canActivate: [AuthGuard],
  },
  {
    path: "contacts",
    component: ContactsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "multifamily",
    component: MultifamilyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "equipment-form",
    component: EquipmentFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "equipment",
    component: EquipmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "view-equipment",
    component: ViewEquipmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "view-system",
    component: ViewSystemComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "design-form",
    component: DesignFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "design",
    component: DesignComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "copySystem",
    component: CopySystemComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "design-systems",
    component: SystemDesignComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "design-overview",
    component: DesignOverviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "system",
    component: SystemComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "new-system",
    component: NewSystemComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "new-system-design",
    component: NewSystemDesignComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dev",
    component: HVACreviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "billing",
    component: BillingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "view-system-equipment-design",
    component: ViewSystemEquipmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "newSystem_dsg_room",
    component: NewSystemDesignRoomComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "homes",
    component: HomesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "locations",
    component: LocationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "hvacLocations",
    component: HvacLocationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "location-overview",
    component: ViewLocationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "location-form",
    component: LocationFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "locations-select-designs",
    component: LocationsSelectDesignsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "confirm-location-design",
    component: ConfirmLocationDesignComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "locations",
    component: HvacLocationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "help",
    component: HelpComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "plans",
    component: PlansComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "customers",
    component: CustomersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "subdivisions",
    component: SubdivisionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "jobtypes",
    component: JobtypesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cities",
    component: CitiesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "employees",
    component: EmployeesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "employee-tree",
    component: EmployeeTreeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "customerjobs",
    component: CustomerJobsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "visualmap",
    component: VisualmapComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "home",
    component: HomecontainerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "billing",
    component: BillingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "viewJobs/:street_address/:id",
    component: ViewJobLocationsComponent,
    canActivate: [AuthGuard],
  },
  {
    // Identity-free deep link to a location's Extra Notes feed, for links embedded
    // in external CSV reports. Bounces to /m/extra-notes/:id with the CURRENT
    // user's identity filled in. See ExtraNotesRedirectComponent.
    path: "extra-notes/:location_id",
    component: ExtraNotesRedirectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "raterform",
    component: RaterformComponent,
    data: { data: {} },
    canActivate: [AuthGuard],
  },
  {
    path: "estar",
    component: BuilderchecklistsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "heatmap",
    component: HeatmapComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "version",
    component: VersionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "timetracking",
    component: TimetrackingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "csvreports",
    component: CsvreportsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "indivaudits",
    component: IndivAuditsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "timeadjustments",
    component: TimeadjustmentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "builderconfirmations",
    component: BuilderConfirmationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "onourwaylog",
    component: OnOurWayLogComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "training",
    component: TrainingDashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "training/employee/:id",
    component: EmployeeTrainingDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "",
    component: LoginComponent,
  },
  {
    path: "**",
    component: LoginComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
